import { render } from "./IconCasePageProductCategories.vue?vue&type=template&id=b1f0407a&scoped=true"
const script = {}

import "./IconCasePageProductCategories.vue?vue&type=style&index=0&id=b1f0407a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f0407a"]])

export default __exports__